export default [
  {
    path: "/From",
    name: "From",
    component: () => import("../../view/From/index.vue"),
    meta: {
      // 判断此页是否需要登录
      requireAuth: true,
    },
    redirect: "/From/device",
    children: [
      {
        path: "device",
        name: "FromDevice",
        component: () => import("../../view/From/view/device.vue"),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/router/modules/from.js